var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:[_vm.b(),_vm.sizeCls,_vm.b('icon')],style:(_vm.sizeStyle)},[(_vm.src)?_c('img',{class:_vm.b('images'),attrs:{"src":_vm.src,"alt":""}}):(_vm.icon)?_c('i',{class:_vm.icon}):_c('span',{ref:"avatarChildren",class:_vm.b('string'),style:(_vm.sizeChildrenStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }